const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }

  if (!values.visibleTo) {
    errors.visibleTo =
      'Selecione ao menos um responsável ou aluno, para qual este canal estará visível';
  }

  if (!values.employees) {
    errors.employees =
      'Selecione ao menos um funcionário que irá atender neste canal';
  }

  return errors;
};
export default validate;
